import classnames from 'classnames';
import Button from 'components/helpers/Button';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import { Routes } from '.generated/templates/Project.Routes.model';
import getThemeClasses from 'lib/util/theming';
import ImageWrapper from '../ImageWrapper/ImageWrapper';
import { getLinkAndHeaderProps, PageCardProps } from './card-utils';
import VideoItem, { VideoItemProps } from 'components/helpers/VideoItem/VideoItem';
import { ImageField, useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import CardHeading from './cardHeading';

export type GenericPage = Sitecore.Override.ItemEx & Routes.Fields.GenericPage;

const GenericPageCard = (props: PageCardProps): React.JSX.Element => {
  const { promotedPage, isSingleCard, onGtmPush } = props;
  const { sitecoreContext } = useSitecoreContext();
  if (!promotedPage) {
    return <></>;
  }
  const genericPage = promotedPage as GenericPage & {
    fields: {
      pageFeaturedVideo?: VideoItemProps;
    };
  };

  const featuredImage = genericPage.fields.pageFeaturedImage.value?.src
    ? genericPage.fields.pageFeaturedImage
    : (sitecoreContext.defaultFeaturedImage as ImageField);

  const { linkField, headingProps } = getLinkAndHeaderProps(props, false);
  return (
    <>
      <div className={classnames('callout-card-img')}>
        {!genericPage.fields.pageFeaturedVideo ? (
          <ImageWrapper field={featuredImage} layout="responsive" />
        ) : (
          <div
            className={classnames(
              'col-span-2',
              'md:col-span-1',
              'lg:col-span-2',
              'md:grid-cols-2',
              'lg:grid-cols-3'
            )}
          >
            <VideoItem {...genericPage.fields.pageFeaturedVideo} hideVideoContent />
          </div>
        )}
      </div>
      <div
        className={classnames('callout-card-content max-h-full', getThemeClasses('theme-white'))}
      >
        <CardHeading
          headingProps={headingProps}
          // imageCaption={imageCaption}
          isSingleCard={isSingleCard}
        />
        <div className={classnames('cta-container')}>
          <Button
            linkField={linkField}
            className={classnames('mr-2', 'sm:mr-4')}
            onGtmPush={onGtmPush}
          />
        </div>
      </div>
    </>
  );
};

export default GenericPageCard;
